import { useQuery } from '@tanstack/react-query'
import { api } from '@api'

interface BusinessCardScan {
  imageUrl: string
  parsedData: {
    firstName: string | null
    lastName: string | null
    email: string | null
    phone: string | null
    company: string | null
    jobTitle: string | null
    website: string | null
    linkedin: string | null
    address: string | null
  }
}

const fetchBusinessCardScan = async (ghostProfileId: string): Promise<BusinessCardScan | null> => {
  const { data } = await api.get<BusinessCardScan | null>(`/ft_business-card-scan/${ghostProfileId}`)
  return data
}

export const useGetBusinessCardScan = (ghostProfileId: string | undefined) => {
  return useQuery<BusinessCardScan | null>({
    queryKey: ['ft_business_card_scan', ghostProfileId],
    queryFn: () => fetchBusinessCardScan(ghostProfileId!),
    enabled: !!ghostProfileId,
  })
}
